module.exports = __webpack_public_path__ + "img/header_banner.6892771a.png";